export default 'production'


// WEBPACK FOOTER //
// ./src/mode.js